/**
 * Shared gtag helper and global type declarations for consent management.
 * Imported by both one-trust.tsx and consent-banner.logic.ts.
 */
import type { AnyObject } from '@sola/schema/dotcom/helpers.ts';

declare global {
  var dataLayer: AnyObject[];

  var OneTrust:
    | {
        OnConsentChanged: (callback: () => void) => void;
        GetDomainData: () => { Groups: unknown[] };
        ToggleInfoDisplay: () => void;
        AllowAll: () => void;
        RejectAll: () => void;
        Close: () => void;
        getGeolocationData: () => { country: string; state: string };
      }
    | undefined;

  var OnetrustActiveGroups: string | undefined;

  var OptanonWrapper: (() => void) | undefined;
}

/** Push to the dataLayer (Google Tag Manager / Consent Mode). */
export const gtag = (...args: unknown[]) => {
  globalThis.dataLayer = globalThis.dataLayer || [];
  globalThis.dataLayer.push(args);
};
